import React from 'react';

export default function FlamelessThermalOxidizerIcon({
  width = 64,
  height = 96,
  startColor = '#4C4C4C',
  midColor = '#FFFF00',
  endColor = '#4C4C4C'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 75.002 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_Oxidizer">
	<rect x="9.442" y="12.348" fill="none" stroke="#4C4C4C" strokeWidth="0.1001" width="56.008" height="100.152" />
	<path fill="#FFD9B2" stroke="#4C4C4C" strokeWidth="0.0996" d="M37.105,26.683c12.438,0,23.178-3.025,28.347-7.424   c0-3.921,0-7.847,0-11.768c-5.169-4.422-15.909-7.424-28.347-7.424c-11.896,0-22.263,2.761-27.641,6.865c0,4.104,0,8.781,0,12.877   C14.842,23.907,25.209,26.683,37.105,26.683z" />
	<rect x="9.526" y="12.596" fill="#FFD9B2" width="55.841" height="100.152" />
</g>
<g id="Group_FLameless_Inner_Layer">
	<path fill="#FFFF00" d="M37.214,27.5c10.358,0,19.302-2.65,23.608-6.503c0-3.436,0-6.874,0-10.31   c-4.307-3.874-13.25-6.503-23.608-6.503c-9.908,0-18.542,2.419-23.021,6.014c0,3.595,0,7.693,0,11.281   C18.672,25.067,27.306,27.5,37.214,27.5z" />
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="37.4988" y1="93.6982" x2="37.4988" y2="14.2285">
		<stop offset="0" style={{stopColor: "#FF6100"}} />
		<stop offset="1" style={{stopColor: "#FFFF00"}} />
	</linearGradient>
	<rect x="14.22" y="14.228" fill={`url(#${id}_1_)`} width="46.556" height="79.47" />
</g>
<g id="Group_Feeder">
	<path fill="#FF0000" d="M60.925,93.693v14.077h-46.96v-4.729H0.001v-9.348H60.925z" />
	<path fill="#FF7F00" d="M75.001,75H60.925v9.234h14.076V75z" />
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.25" d="M0.001,103.041h13.964v4.729h46.96V84.347h14.076" />
</g>
<g id="Group_Coils">
	<path fill="none" stroke="#4C4C4C" strokeWidth="0.5" d="M13.965,88.964h3.716V16.329h7.208v72.635h3.49V16.329h7.32v72.635h3.491   V16.329h7.319v72.635h3.491V16.329h7.207v72.635h3.717" />
</g>
    
      </g>
      <rect x="0" y="0" width="75.002" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
